<template>
	<div class="infoMyBox">
		<div class="infoMyTop">
			<dialogBox :dialogFlag="dialogFlag" @callFn="gbFn" title="修改姓名" @qrsFn="qrsFn">
				<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px">
					<el-form-item label-width="10px" prop="name">
						<el-input v-model="ruleForm.name" autocomplete="off"></el-input>
					</el-form-item>
				</el-form>
			</dialogBox>
			<div class="infoMyIcon">
				<div class="icon">
					<div class="icons" v-if="!infoData.avatar">
						<i class="el-icon-user-solid"></i>
					</div>
					<img :src="$imgUrl + infoData.avatar" v-if="infoData.avatar" alt="" />
					<div class="heiIcon">
						<el-upload
							class="avatar-uploader"
							:action="upHttpUrl"
							:before-upload="befUpfn"
							:http-request="uploadImage"
							:show-file-list="false"
							:on-success="handleAvatarSuccess"
						>
							<div class="upBox">编辑</div>
						</el-upload>
					</div>
				</div>
				<h2>
					{{ infoData.nickName }}
					<img src="@/assets/img/bianj.svg" alt="" @click="zsFn" />
				</h2>
			</div>
			<div class="infoMyVip infoMyPut" v-if="infoData.authority == 0">
				<i class="el-icon-user-solid"></i>
				<span>普通老师</span>
			</div>
			<div class="infoMyVip" v-if="infoData.authority == 1">
				<img src="@/assets/img/hys.svg" alt="" />
				<span>会员老师</span>
			</div>
		</div>
		<div class="infoCont">
			<div class="infoItem">
				<div class="infoH1" @click="btns('grXinx')">
					<img src="@/assets/img/xinx.svg" alt="" />
					<span>个人信息</span>
				</div>
			</div>
			<div class="infoItem">
				<div class="infoH1">
					<img src="@/assets/img/sczy@2x.png" alt="" />
					<span>上传资源</span>
				</div>
				<p @click="btns('zzAdmin')" :class="{ tabActive: typeFlag == 'zzAdmin' }">资源管理</p>
				<p @click="btns('jifenMy')" :class="{ tabActive: typeFlag == 'jifenMy' }">我的积分</p>
			</div>
			<div class="infoItem">
				<div class="infoH1">
					<img src="@/assets/img/sc (1).svg" alt="" />
					<span>我的收藏</span>
				</div>
				<p @click="btns('meiw')" :class="{ tabActive: typeFlag == 'meiw' }">美&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;文</p>
				<p @click="btns('yanJiang')" :class="{ tabActive: typeFlag == 'yanJiang' }">演&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;讲</p>
				<p @click="btns('geQu')" :class="{ tabActive: typeFlag == 'geQu' }">歌&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;曲</p>
				<p @click="btns('dianYing')" :class="{ tabActive: typeFlag == 'dianYing' }">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;影</p>
				<p @click="btns('zuijinKs')" :class="{ tabActive: typeFlag == 'zuijinKs' }">最新试卷</p>
				<p @click="btns('meiqiKj')" :class="{ tabActive: typeFlag == 'meiqiKj' }">每期课件</p>
				<p @click="btns('tongbuKj')" :class="{ tabActive: typeFlag == 'tongbuKj' }">同步课件</p>
				<p @click="btns('kuozhanYd')" :class="{ tabActive: typeFlag == 'kuozhanYd' }">扩展阅读</p>
				<p @click="btns('shuangyuXw')" :class="{ tabActive: typeFlag == 'shuangyuXw' }">双语新闻</p>
				<p @click="btns('meiriYt')" :class="{ tabActive: typeFlag == 'meiriYt' }">每日一听</p>
				<p @click="btns('gaokaoZt')" :class="{ tabActive: typeFlag == 'gaokaoZt' }">高考真题</p>
				<p @click="btns('shitiLz')" :class="{ tabActive: typeFlag == 'shitiLz' }">试题篮子</p>
				<p @click="btns('huzhuGx')" :class="{ tabActive: typeFlag == 'huzhuGx' }">互助共享</p>
				<p @click="btns('changyongGj')" :class="{ tabActive: typeFlag == 'changyongGj' }">常用工具</p>
			</div>
			<div class="infoItem">
				<div class="infoH1" @click="fkBtn">
					<img src="@/assets/img/bz (1).svg" alt="" />
					<span>帮助中心</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';
import { mapState } from 'vuex';

export default {
	name: 'inFo',
	data() {
		return {
			rules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},
			ruleForm: {
				name: ''
			},
			txImg: '',
			typeFlag: '',
			dialogFlag: false,
			upHttpUrl: '',
			upHttpKey: '',
			wjName: ''
		};
	},
	computed: {
		...mapState(['infoData'])
	},
	components: {
		dialogBox
	},
	methods: {
		uploadImage(file) {
			// 这里的`file`参数是要上传的文件对象
			// 在这里根据需要添加一些逻辑，如显示进度条
			const xhr = new XMLHttpRequest();
			//element-ui默认使用post提交，但是我们生成的url需要使用 put 提交
			//需要指定 put 直传，以及this.upHttpUrl（后端返回的url）
			xhr.open('PUT', this.upHttpUrl, true);
			//设置上传文件的类型
			xhr.setRequestHeader('Content-Type', file.file.type); // 或者 file.type
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						//进入到这里就表明上传成功了
						//我这里对后端返回的url进行截取方便存入数据库，因为前端还需要展示图片
						let indexOf = this.upHttpUrl.indexOf('?');
						console.log(this.upHttpUrl.slice(0, indexOf), xhr.response, 55555);
						this.$http
							.post('api/app/common/upFileAttachment', {
								key: this.upHttpKey,
								originalFileName: this.wjName
							})
							.then((red) => {
								if (red.code == 200) {
									let set = this.$loading(this.$pre);
									this.$http
										.post('api/app/login/upDataUser', {
											avatar: red.data.attDir
										})
										.then((red) => {
											set.close();
											if (red.code == 200) {
												this.$message({
													message: '修改成功',
													type: 'success'
												});
												this.infoInit();
											}
										});
								}
								// this.localImg = this.$imgUrl + red.data.attDir;
							});
					} else {
					}
				}
			};
			//发送
			xhr.send(file.file); //或者 file
		},
		async befUpfn(e) {
			console.log(e, 7777);
			this.wjName = e.name;
			await this.$http
				.get('api/app/common/getToken', {
					params: {
						fileName: e.name
					}
				})
				.then((res) => {
					console.log(9999);
					this.upHttpUrl = res.data.host;
					this.upHttpKey = res.data.key;
				});
		},
		zsFn() {
			this.dialogFlag = true;
		},
		gbFn() {
			this.$nextTick(() => {
				this.$refs.ruleForm.resetFields();
				this.dialogFlag = false;
			});
		},
		qrsFn() {
			this.$nextTick(() => {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let set = this.$loading(this.$pre);
						this.$http
							.post('api/app/login/upDataUser', {
								nickName: this.ruleForm.name
							})
							.then((res) => {
								set.close();
								if (res.code == 200) {
									this.$message({
										message: '修改成功',
										type: 'success'
									});
									this.dialogFlag = false;
									this.infoInit();
									this.$refs.ruleForm.resetFields();
									this.$nextTick(() => {
										this.gsFlag = false;
									});
								}
							});
					}
				});
			});
		},
		handleAvatarSuccess(res) {
			console.log(res, 999);
			if (res.code == 200) {
				let set = this.$loading(this.$pre);
				this.$http
					.post('api/app/login/upDataUser', {
						avatar: res.data.url
					})
					.then((red) => {
						set.close();
						if (red.code == 200) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.infoInit();
						}
					});
			}
		},
		btns(cont) {
			if (cont == 'shitiLz') {
				this.$emit('lzFn');
			}
			this.typeFlag = cont;
			this.$emit('currCompBtn', cont);
		},
		infoInit() {
			this.$http.get('api/app/login/getInfo').then((res) => {
				if (res.code == 200) {
					this.$store.commit('setInfoData', res.data);
				}
			});
		},
		fkBtn() {
			this.$router.push({
				path: 'feedback'
			});
		}
	},
	activated() {
		let { routeName } = this.$route.query;
		if (routeName) {
			this.typeFlag = 'shitiLz';
		}
	}
};
</script>
<style lang="scss" scoped>
.tabActive {
	color: #1d7b3a !important;
}
.infoMyBox {
	width: 187px;
	background: #fff;
	border-radius: 6px;
	padding: 0 10px;
	.infoCont {
		padding: 46px 0 31px 9px;
		.infoItem {
			margin-bottom: 30px;
			&:last-of-type {
				margin-bottom: 0;
			}
			.infoH1 {
				display: flex;
				align-items: center;
				cursor: pointer;

				img {
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
				span {
					color: #1d7b3a;
					font-size: 14px;
					font-weight: bold;
				}
			}
			p {
				color: #000000;
				font-size: 14px;
				margin-top: 20px;
				padding-left: 24px;
				cursor: pointer;
				&:hover {
					color: #1d7b3a;
				}
			}
		}
	}
	.infoMyTop {
		border-bottom: 1px solid #f8f8f8;
	}
	.infoMyIcon {
		padding-top: 41px;
		text-align: center;

		.icon {
			width: 93px;
			height: 93px;
			margin: 0 auto 15px;
			border-radius: 50%;
			overflow: hidden;
			cursor: pointer;
			position: relative;
			.icons {
				width: 93px;
				height: 93px;
				display: flex;
				background: #f1f2f5;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				margin-right: 7px;

				i {
					font-size: 24px;
					font-size: 48px;
					color: #babbbe;
				}
			}
			&:hover {
				.heiIcon {
					display: flex;
				}
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
			.heiIcon {
				background: rgba(0, 0, 0, 0.4);
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				top: 0;
				display: none;
				color: #fff;
				justify-content: center;
				align-items: center;
				font-size: 14px;
				.upBox {
					width: 100%;
					height: 100%;
					position: absolute;
					display: flex;
					justify-content: center;
					align-items: center;
					top: 0;
					left: 0;
				}
			}
		}
		h2 {
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: bold;
			margin-bottom: 17px;

			img {
				width: 14px;
				height: 14px;
				margin-left: 5px;
				cursor: pointer;
			}
		}
	}
	.infoMyVip {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 93px;
		height: 27px;
		background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
		border-radius: 4px;
		color: #93571c;
		font-size: 14px;
		margin: 0 auto 23px;
		img {
			width: 18px;
			height: 18px;
			margin-right: 6px;
		}
	}
	.infoMyPut {
		background: linear-gradient(90deg, rgba(97, 161, 255, 0.22) 0%, rgba(0, 118, 255, 0.31) 100%);
		color: #0c7bfd;
		i {
			font-size: 18px;
			margin-right: 6px;
			line-height: 1.2;
		}
	}
}
</style>
